export default __webpack_public_path__ + "static/media/check.a1200f1a.svg";